import { useState, useEffect, useRef } from "react";
import { Send, MessageCircle, MinusCircle, X } from "lucide-react";

export default function ChatWidget() {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatMinimized, setChatMinimized] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([
    { id: 1, type: "assistant", content: "Bonjour ! Comment puis-je vous aider avec vos projets de voyage ?" },
  ]);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const handleSendChat = (e) => {
    e.preventDefault();
    if (!chatMessage.trim()) return;
    setChatMessages((prev) => [
      ...prev,
      { id: prev.length + 1, type: "user", content: chatMessage },
      { id: prev.length + 2, type: "assistant", content: "Je suis là pour vous aider. Un agent vous répondra dans quelques instants." },
    ]);
    setChatMessage("");
  };

  return (
    <>
      {!chatOpen && (
        <button
          onClick={() => setChatOpen(true)}
          className="fixed bottom-6 right-6 bg-brand-600 text-white p-3.5 rounded-full shadow-lg hover:bg-brand-700 transition-colors z-50"
          aria-label="Ouvrir le chat"
        >
          <MessageCircle size={22} />
        </button>
      )}
      {chatOpen && (
        <div className={`fixed bottom-6 right-6 w-80 bg-white rounded-2xl shadow-2xl z-50 flex flex-col transition-all duration-200 ${chatMinimized ? "h-12" : "h-96"}`}>
          <div className="bg-brand-700 text-white px-4 py-2.5 rounded-t-2xl flex justify-between items-center">
            <span className="font-semibold text-sm">Assistant Niger Voyage</span>
            <div className="flex items-center gap-1.5">
              <button onClick={() => setChatMinimized(!chatMinimized)} className="hover:text-white/70 transition-colors">
                <MinusCircle size={16} />
              </button>
              <button onClick={() => setChatOpen(false)} className="hover:text-white/70 transition-colors">
                <X size={16} />
              </button>
            </div>
          </div>
          {!chatMinimized && (
            <>
              <div className="flex-1 overflow-y-auto p-3 space-y-2.5">
                {chatMessages.map((msg) => (
                  <div key={msg.id} className={`flex ${msg.type === "user" ? "justify-end" : "justify-start"}`}>
                    <div className={`max-w-[85%] px-3 py-2 rounded-xl text-xs ${msg.type === "user" ? "bg-brand-600 text-white" : "bg-slate-100 text-slate-700"}`}>
                      {msg.content}
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
              <form onSubmit={handleSendChat} className="p-2.5 border-t border-slate-100 flex gap-2">
                <input
                  type="text"
                  value={chatMessage}
                  onChange={(e) => setChatMessage(e.target.value)}
                  placeholder="Écrivez votre message..."
                  className="flex-1 px-3 py-1.5 text-xs border border-slate-200 rounded-lg focus:outline-none focus:border-brand-500"
                />
                <button
                  type="submit"
                  disabled={!chatMessage.trim()}
                  className="bg-brand-600 text-white p-1.5 rounded-lg hover:bg-brand-700 transition-colors disabled:opacity-40"
                >
                  <Send size={14} />
                </button>
              </form>
            </>
          )}
        </div>
      )}
    </>
  );
}
